import styled from 'styled-components';

const FeaturedContentInnerContainer = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  margin: 0 auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
`;

const RichTextContainer = styled.div`
  margin-top: 20px;

  p {
    font-size: var(--font-size-16);
  }
`;

export { FeaturedContentInnerContainer, RichTextContainer };
